import { Typography as T } from 'antd'

export const { Text } = T
export const { Paragraph } = T
export const { Title } = T

const Typography = {
  Text,
  Paragraph,
  Title,
}

export default Typography
